import { React } from 'react';
import moment from 'moment';
import './article.scss';

export const Article = ({ title, content, date, archive, ...props }) => {
  var decodeHTML = function (html) {
    var txt = document.createElement('textarea');
    txt.innerHTML = html;
    return txt.value;
  };

  return (
    <div className={`article-component`}>
      <div className="article-date">{moment(date).format('MMMM D, YYYY')}</div>
      <h1 className="article-title">{title}</h1>
      <article
        className="article-content"
        dangerouslySetInnerHTML={{ __html: decodeHTML(content) }}
      />
    </div>
  );
};

Article.propTypes = {};
